import { render } from "./PageHeader.vue?vue&type=template&id=6d7b7363&scoped=true"
import script from "./PageHeader.vue?vue&type=script&lang=ts"
export * from "./PageHeader.vue?vue&type=script&lang=ts"

import "./PageHeader.vue?vue&type=style&index=0&id=6d7b7363&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6d7b7363"

export default script